<script>
	//Gradient Picker
	export let startCol = "#00ffcc";
	export let endCol = "#0099ff";
	export let angle = 0;

	import { colorAvg } from "../tools.js";

	$: mid = colorAvg(startCol, endCol);

	function swapColors() {
		let startNew = endCol;
		let endNew = startCol;

		[startCol, endCol] = [startNew, endNew];
	}

	function rotateAngle() {
		angle += 45;

		if (angle >= 360) {
			angle = 0;
		}
	}
</script>

<div class="--gradient-picker">

	<div class="--gradient">
		<div class="--grad-out"
			style="background: linear-gradient(90deg, {startCol}, {mid}, {endCol});"
		>
			&nbsp;
		</div>

		<div class="--col" style="background-color: {startCol}">
			<label for="start">Start</label>
			<input id="start" type="color" bind:value={startCol} />
		</div>

		<div class="--swap">
			<button on:click={swapColors}>
				<img src="img/arrows-exchange.svg" alt="swap" />
				<span>Swap Colors</span>
			</button>
		</div>

		<div class="--col" style="background-color: {endCol}">
			<label for="end">Start</label>
			<input id="end" type="color" bind:value={endCol} />
		</div>
	</div>

	<div class="--rotate">
		<button class="icon" on:click={rotateAngle}>
    		<div class="indicator" style="background-image: linear-gradient({angle}deg, transparent 50%, rgb(192, 192, 192))">
    			&nbsp;
    		</div>
    		<img src="img/rotate-clockwise.svg" alt="Rotate Gradient">
            <span>Rotate Gradient</span>
		</button>
		<output>{angle}</output>
	</div>

</div>

<style>
	div.--gradient-picker {
		position: relative;
		min-width: 15rem;
		min-height: 3rem;
		display: flex;
		flex-wrap: nowrap;
		gap: 0.5rem;
	}

	div.--gradient-picker button img {
	    filter: none;
			margin: 0;
	}

	div.--gradient-picker button span {
		position: absolute;
		width: 0;
		height: 0;
		overflow: hidden;
		opacity: 0;
	}

	div.--gradient {
		position: relative;
		display: flex;
		justify-content: space-between;
		flex-grow: 1;
		align-items: center;
		min-height: 3rem;
		padding: 0 0.75rem;
		border: 2px solid #333;
		border-radius: 2px;
		z-index: 4;
	}

	div.--grad-out {
		position: absolute;
		inset: 2px;
		border-radius: 2px;
		z-index: -1;
	}

	div.--col {
		position: relative;
		width: 2rem;
		height: 2rem;
		border: 4px solid #fff;
		border-radius: 99px;
		transition: all ease 0.25s;
		cursor: pointer;
	}

	div.--col:hover, div.--col:focus-within {
		transform: scale(1.1);
		box-shadow: 2px 2px 8px rgb(192 192 192 / 0.4);
	}

	div.--gradient input[type="color"] {
		-webkit-appearance: none;
		appearance: none;
		position: absolute;
		top: -4px;
		left: -4px;
		padding: 0;
		width: 2rem;
		height: 2rem;
		opacity: 0;
		cursor: pointer;
	}

	div.--gradient label {
		position: absolute;
		width: 0;
		height: 0;
		opacity: 0;
		overflow: hidden;
		display: block;
	}

	div.--swap button {
        background-color: #eee;
     	cursor: pointer;
		width: 2.0rem;
		height: 2.0rem;
		padding: 0.2rem;
		border-radius: 99px;
		border: none;
		transition: all ease 0.25s;
	}

	div.--swap button:hover,
	div.--swap button:focus {
		filter: brightness(1.2);
	}

	div.--rotate {
		position: relative;
	}

	div.--rotate button {
	    background-color: transparent;
	}

	div.--rotate output {
		position: absolute;
		width: 0;
		height: 0;
		overflow: hidden;
		opacity: 0;
	}

	.indicator {
        position: absolute;
        inset: 2px;
        opacity: 0;
        transition: opacity ease 0.25s;
	    z-index: -1;
    }

    div.--rotate button:hover .indicator,
    div.--rotate button:focus .indicator {
      opacity: 1;
    }



</style>
